import {
  GET_LIST_CUSTOMER,
  GET_LIST_CUSTOMER_SUCCESS,
  GET_LIST_CUSTOMER_FAILURE,
  GET_DETAIL_CUSTOMER,
  GET_DETAIL_CUSTOMER_SUCCESS,
  GET_DETAIL_CUSTOMER_FAILURE,
  LICH_SU_GIAO_DICH_CUSTOMER,
  LICH_SU_GIAO_DICH_CUSTOMER_SUCCESS,
  LICH_SU_GIAO_DICH_CUSTOMER_FAILURE,
  GET_AUTOCOMPLETE_CUSTOMER,
  GET_AUTOCOMPLETE_CUSTOMER_SUCCESS,
  GET_AUTOCOMPLETE_CUSTOMER_FAILURE,
} from "actions/Customer/actionTypes";

const initialState = {
  customerLoading: false,
  posts: [],
  customerDetail: {},
  objLichSuGiaoDich: {
    LoaiDoiTac: "",
    TongGiaoDich: "0",
    TongTienChoVay: 0.0,
    List: [],
  },
  autocompleteData: [],
};

const getListCustomer = (state, action) => ({
  ...state,
  customerLoading: true,
});

const getListCustomerSuccess = (state, action) => {
  return {
    ...state,
    customerLoading: false,
    posts: action.payload,
  };
};

const getListCustomerFailed = (state, action) => ({
  ...state,
  customerLoading: false,
  posts: [],
});

const getDetailCustomer = (state, action) => ({
  ...state,
  customerLoading: true,
});

const getDetailCustomerSuccess = (state, action) => {
  return {
    ...state,
    customerLoading: false,
    customerDetail: action.payload ? action.payload : {},
  };
};

const getDetailCustomerFailed = (state, action) => ({
  ...state,
  customerLoading: false,
  customerDetail: {},
});

const lichSuGiaoDich = (state, action) => ({
  ...state,
  customerLoading: true,
});

const lichSuGiaoDichSuccess = (state, action) => {
  return {
    ...state,
    customerLoading: false,
    objLichSuGiaoDich: action.payload,
  };
};

const lichSuGiaoDichFailed = (state, action) => ({
  ...state,
  customerLoading: false,
  objLichSuGiaoDich: {
    LoaiDoiTac: "",
    TongGiaoDich: "0",
    TongTienChoVay: 0.0,
    List: [],
  },
});

const getAutocompleteCustomer = (state, action) => ({
  ...state,
  customerLoading: true,
});

const getAutocompleteCustomerSuccess = (state, action) => {
  return {
    ...state,
    customerLoading: false,
    autocompleteData: action.payload,
  };
};

const getAutocompleteCustomerFailed = (state, action) => ({
  ...state,
  customerLoading: false,
  autocompleteData: [],
});
const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CUSTOMER:
      return getListCustomer(state, action);
    case GET_LIST_CUSTOMER_SUCCESS:
      return getListCustomerSuccess(state, action);
    case GET_LIST_CUSTOMER_FAILURE:
      return getListCustomerFailed(state, action);
    case GET_DETAIL_CUSTOMER:
      return getDetailCustomer(state, action);
    case GET_DETAIL_CUSTOMER_SUCCESS:
      return getDetailCustomerSuccess(state, action);
    case GET_DETAIL_CUSTOMER_FAILURE:
      return getDetailCustomerFailed(state, action);
    case LICH_SU_GIAO_DICH_CUSTOMER:
      return lichSuGiaoDich(state, action);
    case LICH_SU_GIAO_DICH_CUSTOMER_SUCCESS:
      return lichSuGiaoDichSuccess(state, action);
    case LICH_SU_GIAO_DICH_CUSTOMER_FAILURE:
      return lichSuGiaoDichFailed(state, action);
    case GET_AUTOCOMPLETE_CUSTOMER:
      return getAutocompleteCustomer(state, action);
    case GET_AUTOCOMPLETE_CUSTOMER_SUCCESS:
      return getAutocompleteCustomerSuccess(state, action);
    case GET_AUTOCOMPLETE_CUSTOMER_FAILURE:
      return getAutocompleteCustomerFailed(state, action);
    default:
      return state;
  }
};

export default customerReducer;
